function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.513 2.487C11.19-.83 5.809-.83 2.49 2.49a8.496 8.496 0 000 12.018 8.504 8.504 0 0012.023.004 8.513 8.513 0 000-12.026zm-2.68 8.337a.708.708 0 01-.998 1.003L8.63 9.623a.176.176 0 00-.251 0l-2.204 2.204a.722.722 0 01-1.003 0 .71.71 0 010-1.003L7.376 8.62a.174.174 0 000-.25L5.172 6.166a.708.708 0 01.999-1.003l2.204 2.205c.034.033.079.052.126.052s.092-.02.125-.052l2.205-2.205a.71.71 0 111.003 1.003L9.629 8.37a.175.175 0 000 .25l2.205 2.204z"
});

function SvgCloseGreyCircleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17
  }, props), _ref);
}

export default SvgCloseGreyCircleFill;